/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */

import { Component, Input } from '@angular/core';
import { cva, VariantProps } from 'class-variance-authority';

export const searchResultLayerVariants = cva(
  'empty:hidden z-50 mt-3 w-full rounded-lg border border-primary/50 bg-background-50 shadow-lg focus-visible:outline-focus focus-visible:outline-2',
  {
    variants: {
      variant: {
        default: 'absolute max-h-[calc(37vh)] overflow-y-auto',
        'user-profile': 'absolute max-h-68 overflow-y-auto',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export type SearchResultLayerVariants = VariantProps<typeof searchResultLayerVariants>;

@Component({
  selector: 'ods-search-result-layer',
  host: {
    role: 'listbox',
    'aria-label': 'Suchergebnisse',
    '[class]': 'searchResultLayerVariants({ variant })',
  },
  template: `
    <ng-content select="[header]" />
    <ng-content />
  `,
})
export class SearchResultLayerComponent {
  @Input() variant: SearchResultLayerVariants['variant'];

  readonly searchResultLayerVariants = searchResultLayerVariants;
}
